export default "__VITE_ASSET__8a053a72__"